import {useGetHasPermissions} from "@/src/modules/core/store/me";

export function useSectionPermissions(
  section: string,
  actions: string[],
): Record<string, boolean> {
  const getHasPermission = useGetHasPermissions();

  return actions.reduce<Record<string, boolean>>((acc, a) => {
    acc[a] = getHasPermission(`${section} ${a}`);
    return acc;
  }, {});
}
